export default __webpack_public_path__ + "images/t-contract-edit-cancel-account.svg";